import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('../views/Shop.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/product/:name',
    name: 'productPage',
    component: () => import('../views/ProductPage.vue')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue')
  },
  {
    path: '/summarise-order',
    name: 'Summarise',
    component: () => import('../views/Summarise.vue')
  },
  {
    path: '/confirmation',
    name: 'OrderSuccess',
    props: true,
    component: () => import('../views/OrderSuccess.vue')
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('../views/Rules.vue')
  },
  {
    path: '/returns',
    name: 'Returns',
    component: () => import('../views/Returns.vue')
  },
  {
    path: '/cookies',
    name: 'Cookies',
    component: () => import('../views/Cookies.vue')
  },
  {
    path: '/lookbook',
    name: 'Lookbook',
    component: () => import('../views/Lookbook.vue')
  },
  {
    path: '/spotfinder',
    name: 'Spotfinder',
    component: () => import('../views/Spotfinder.vue')
  }
  // {
  //   path: '/agreement',
  //   name: 'CrewAgreement',
  //   component: () => import('../views/CrewAgreement.vue')
  // }
]

const router = new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    document.getElementById('app').scrollTo(0, 0)
    return null
  },
  routes
})

export default router
